import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { styled } from '@material-ui/core/styles';

export const SignatoryCardContainer = styled(Paper)(() => ({
  width: '100%',
  height: '100%',
  border: '1px solid #D8D9E1',
  borderRadius: '20px',
}));

export const signatoryCardTypographyStyle = {
  color: 'rgba(0, 0, 0, 0.6)',
  fontWeight: 700,
};

export const SignatoryCardTypography = styled(Typography)(
  () => signatoryCardTypographyStyle
);
